import ClockIcon from "@redotech/redo-icons/clock-stopwatch.svg";
import { waitStepSeconds } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import {
  WaitStep,
  WaitTimeUnit,
  getTimeValue,
} from "@redotech/redo-model/advanced-flow/steps";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Handle, Position } from "@xyflow/react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";
import * as NodeCSS from "./node.module.css";

export interface WaitNodeData {
  step: PartialWithRequiredType<WaitStep>;
  deleteElements: (id: string) => void;
}

export function WaitNode(data: {
  id: string;
  data: WaitNodeData;
  selected?: boolean | undefined;
}) {
  return (
    <BaseNode
      icon={<RedoFeaturedIcon color="warning" Icon={ClockIcon} size="xs" />}
      onDelete={() => data.data.deleteElements(data.id)}
      selected={data.selected}
      step={data.data.step}
      title="Wait"
    >
      <>
        <Handle position={Position.Top} type="target" />
        <Flex className={NodeCSS.fullWidth} dir="column" justify="flex-start">
          <Text fontSize="xxs">Duration</Text>
          {waitStepSeconds(data.data.step) ? (
            <Text className={NodeCSS.valueText}>
              {getTimeValue({
                seconds: waitStepSeconds(data.data.step) || 0,
                timeUnit: data.data.step.timeUnit || WaitTimeUnit.DAYS,
              }) +
                " " +
                (data.data.step.timeUnit || WaitTimeUnit.DAYS)}
            </Text>
          ) : (
            <Text className={NodeCSS.placeholderText}>Needs configuration</Text>
          )}
        </Flex>
        <Handle position={Position.Bottom} type="source" />
      </>
    </BaseNode>
  );
}
